module.exports = __webpack_public_path__ + "static/media/logo_mgd.46e948ff.jpg";